import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';

const NationalProjectSection = () => {
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: 'white', overflow: 'hidden' }}>
      <Container maxWidth="xl">
        <Grid container spacing={6} alignItems="stretch">
          {/* Левая часть - изображение персонажа */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                backgroundColor: '#e8e8e8',
                borderRadius: 4,
                overflow: 'hidden',
                height: { xs: 450, sm: 550, md: 600 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                maxWidth: { xs: '100%', sm: 500 },
                margin: '0 auto',
              }}
            >
              <Box
                component="img"
                src="/img/1.jpg"
                alt="Персонаж приветствует"
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  objectPosition: 'center',
                }}
              />
            </Box>
          </Grid>

          {/* Правая часть - текст */}
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                height: '100%',
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  mb: 4,
                  fontWeight: 700,
                  color: 'primary.main',
                  fontSize: { xs: '1.1rem', sm: '1.5rem', md: '2.5rem' },
                  textAlign: { xs: 'center', md: 'left' },
                  lineHeight: 1.3,
                  px: { xs: 1, md: 0 },
                  maxWidth: '100%',
                  overflow: 'hidden',
                }}
              >
                <Box component="span" sx={{ display: 'block', whiteSpace: { xs: 'normal', sm: 'nowrap' }, maxWidth: '100%' }}>
                  Консультационный{'\u00A0'}центр
                </Box>
                <Box component="span" sx={{ display: 'block', whiteSpace: { xs: 'normal', sm: 'nowrap' }, maxWidth: '100%' }}>
                  "Волшебная{'\u00A0'}страна"
                </Box>
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  lineHeight: 1.8,
                  color: 'text.secondary',
                  fontSize: { xs: '0.95rem', md: '1.05rem' },
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                КЦ "Волшебная{'\u00A0'}страна" функционирует на базе МАДОУ МО г.{'\u00A0'}Краснодар «Детский{'\u00A0'}сад{'\u00A0'}№{'\u00A0'}213», 
                деятельность центра направлена на пропаганду позитивного и ответственного родительства 
                посредством оказания психолого-педагогической, методической и консультативной помощи
              </Typography>

            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default NationalProjectSection;
